import { render, staticRenderFns } from "./gmv-target-banner.vue?vue&type=template&id=bd0667fc&scoped=true"
import script from "./gmv-target-banner.vue?vue&type=script&lang=js"
export * from "./gmv-target-banner.vue?vue&type=script&lang=js"
import style0 from "./gmv-target-banner.vue?vue&type=style&index=0&id=bd0667fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0667fc",
  null
  
)

export default component.exports